import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IScanServices } from 'src/app/core/services/iscan.service';
import { Scan, ScanSplit, ScanPage, SuperButton } from '@devinforius/super-compos-17';
import { ToastrService } from 'ngx-toastr';
import { ScanSplitButton } from '@devinforius/super-compos-17/lib/i-scan-v3/interfaces/scan-split-button-interface';
import { Page, Scan as ScanDTO, Split } from 'src/app/shared/models/iScanV1/scan';
import { saveAs } from 'file-saver';
import { QrCodeExplode } from 'src/app/shared/pipes/qrCode.pipe';
import { ScanService } from 'src/app/core/services/scan.service';
import { DetailSplit } from '@devinforius/super-compos-17/lib/i-scan-v3/models/detailsSplits';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@devinforius/super-compos-17';
import { NgxSpinnerService } from 'ngx-spinner';
import { getButtonsTitle, getQuickButtonsIScan } from './infos-config';
@Component({
  selector: 'app-detail-scan',
  templateUrl: './detail-scan.component.html',
  styleUrls: ['./detail-scan.component.css'],
})


export class DetailScanComponent implements OnInit {
  loader: boolean = false;
  spinnerCountSave: number = 0;
  spinnerCountTotal: number = 0;
  infosCard: DetailSplit;
  modifyDetailSplitGuid: string;
  openEditDescription: boolean = false;
  guid: string;
  originScan: ScanDTO;
  scan: Scan;
  buttonTitle: SuperButton[];
  buttonsAction: ScanSplitButton[];

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private scanService: ScanService,
    private iscanServices: IScanServices,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    public spinner: NgxSpinnerService,
  ) {}
  
  ngOnInit(): void {
    this.buttonsAction = getQuickButtonsIScan(this.translate);
    this.buttonTitle = getButtonsTitle(this, this.translate);
    this.guid = this.route.snapshot.params['id'];
    if(this.guid){
      this.iscanServices.getIscanData(this.guid).subscribe({
        next: (res: ScanDTO) => {
          this.mapDataScan(res);
        },
        error: () => {
          this.toastr.error(this.translate.translate('iscan.error.errorRetrievingScan'));
        }
      });
    }
  }

  mapDataScan(source: ScanDTO): void {
    this.originScan = source;
    const scan = new Scan();
    scan.guid = source.guid;
    scan.name = source.name;
    scan.nbrPages = source.numPages;
    scan.splitmode = source.splitMode;
  
    const qrTransforms = source.splits.map(split => {
      const qrRaw = split.mainCode;
      const qrTransformed = qrRaw
        ? new QrCodeExplode().transform(qrRaw)
        : null;
      return {
        guidSplit: split.guid,
        qr: qrTransformed  
      };
    });
  
    const allIds = qrTransforms
      .filter(t => t.qr && typeof t.qr.id === 'number')
      .map(t => t.qr.id);
  
    if (allIds.length === 0) {
      const splitBlobRequests: ScanSplit[] = source.splits.map((split, i) => ({
        guid: split.guid,
        name: this.insertIndexIntoFilename(split.name, i + 1),
        isLock: split.lock,
        metadata: split.mainCode,
        details: {
          title: 'Error',
          description: 'Aucun QRCode détecté',
          titleButton: null,
        },
        pages: split.pages.map((page: Page) => ({
          ...page,
          blob: page.url
        }))
      }));
  
      const trashBlobRequests: ScanPage[] = source.pagesDeleted.map((page: Page) => ({
        ...page,
        blob: page.url,
      }));
  
      scan.splits = splitBlobRequests;
      scan.trash = trashBlobRequests;
      this.scan = scan;
      return; 
    }
  
    this.scanService
      .getInfoCourrierByIdQrCode({ courrierIds: allIds })
      .subscribe({
        next: infos => {
          const infoById = new Map<number, { type: string; description: string; id: number }>();
          infos.forEach(i => {
            infoById.set(i.courrierId, { type: i.type, description: i.description, id: i.id });
          });
  
          const splitBlobRequests: ScanSplit[] = source.splits.map((split, i) => {
            const transformRecord = qrTransforms.find(t => t.guidSplit === split.guid);
            let details: DetailSplit;
            if (!split.mainCode) {
              details = {
                title: 'Error',
                description: 'Aucun QRCode détecté',
                titleButton: null,
              };
            } else if (!transformRecord?.qr) {
              details = {
                title: 'Error',
                description: 'QRCode non reconnu',
                titleButton: null,
              };
            } else {
              const info = infoById.get(transformRecord.qr.id);
              if (info) {
                details = {
                  title: info.type,
                  description: info.description,
                  titleButton: info.id.toString(),
                };
              } else {
                details = {
                  title: 'Error',
                  description: this.translate.translate('error.occurred'),
                  titleButton: null,
                };
              }
            }
  
            return {
              guid: split.guid,
              name: this.insertIndexIntoFilename(split.name, i + 1),
              isLock: split.lock,
              metadata: split.mainCode,
              details,
              pages: split.pages.map((page: Page) => ({
                ...page,
                blob: page.url
              }))
            };
          });
  
          const trashBlobRequests: ScanPage[] = source.pagesDeleted.map((page: Page) => ({
            ...page,
            blob: page.url,
          }));
  
          scan.splits = splitBlobRequests;
          scan.trash = trashBlobRequests;
          this.scan = scan;
        },
        error: () => {
          this.toastr.error(this.translate.translate('iscan.error.errorRetrievingInfoQrCode'));
          this.scan = scan;
        }
      });
  }
  
  
  
 
  insertIndexIntoFilename(filename: string, index: number): string {
    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex === -1) {
      return `${filename}-${index}`;
    }
    const name = filename.substring(0, dotIndex);
    const extension = filename.substring(dotIndex);
    return `${name}-${index}${extension}`;
  }

  onScanSplitActionClick(event: {action: string, scanSplit: ScanSplit}): void {
    const index = this.scan.splits.findIndex(split => split.guid === event.scanSplit.guid);
    switch (event.action) {
      case 'modifyScan':
        this.infosCard = this.scan.splits[index].details;
        this.modifyDetailSplitGuid = event.scanSplit.guid;
        this.openEditDescription = true;
        break;
      case 'deleteLink':
        this.scan.splits[index].details = {
          title: null,
          description: null,
          titleButton: null,
        };
        break;
      case 'scrollFile':
        this.scroll(event.scanSplit.pages[0].guid, index);
        break;
      case 'downloadFile':
        this.loadingDownloadFile(this.guid, event.scanSplit);
        break;
    }
  }

  back(): void {
    this.confirmationService.confirm({
      message:  this.translate.translate('iscan.infos.leavePage') + ' ' + this.translate.translate('info.allModifLost'),
      accept: () => {
        this.router.navigate(['private/iscan']);
      },
    });
  }

  // getLanguage(): void {
  //   this.language = localStorage.getItem('lang');
  // }
  
  // @HostListener('window:storage', ['$event'])
  // onStorageChange(event: StorageEvent): void {
  //   if (event.key === 'lang') {
  //     this.getLanguage();
  //   }
  // }

  scroll(id: string, i: number, nocolor?: boolean): void {
    const el = document.getElementById('file_'+i);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const el1 = document.getElementById(id + '_images');
    if (el1 && !nocolor) {
      el1.style.transition = 'background-color 0.1s ease-in';
      el1.style.setProperty('background-color', '#DB952520', 'important');
      setTimeout(() => {
        el1.style.transition = 'background-color 0.8s ease-out';
        el1.style.backgroundColor = '';
      }, 700);
    }
  }

  loadingDownloadFile(fileGuid: string, split: ScanSplit): void {
    this.iscanServices.downloadSplit(fileGuid, split.guid).subscribe({
      next: (res) => {
        const downloadURL = URL.createObjectURL(res);
        saveAs(downloadURL, split.name);
        this.toastr.success(this.translate.translate('iscan.success.download'));
      },
      error: () => {
        this.toastr.error(this.translate.translate('iscan.error.download'));
      }
    });
  }

  newDescription(event): void {
    const index = this.scan.splits.findIndex(split => split.guid === this.modifyDetailSplitGuid);
    if(event) {
      if(event?.objetSynthese) {
        this.scan.splits[index].details.description = event.objetSynthese;
        this.scan.splits[index].details.titleButton = event.id;
        this.scan.splits[index].details.title = 'Point';
      } else {
        this.scan.splits[index].details.description = event?.description;
        this.scan.splits[index].details.titleButton = event?.id;
        this.scan.splits[index].details.title = 'Séance';
      }
    }
    this.modifyDetailSplitGuid = null;
  }

  clickDetailsCard(event: ScanSplit): void {
    if(event.details.title === 'Point') {
      window.open('private/points/detail/' + event.details.titleButton, '_blank');
    } else if(event.details.title === 'Séance') {
      window.open('private/meetings/details/' + event.details.titleButton, '_blank');
    }
  }

  confirmAndSave(): void {
    const scanError = this.scan.splits.filter((element) => element.details.title === 'Error');
    const scanLinked = this.scan.splits.filter((element) => element.details.title === null);
    if(scanError.length === 0 && scanLinked.length === 0) {
      this.saveFile();
      return;
    }
    let message = '';
    if (scanError.length > 0) {
      message += scanError.length + ' ' + this.translate.translate('iscan.error.scanError');
    }
    
    if (scanLinked.length > 0) {
      if (message.length > 0) {
        message += ' et ';
      }
      message += scanLinked.length + ' ' + this.translate.translate('iscan.error.scanNotLink');
    }
    
    if (message.length > 0) {
      message += this.translate.translate('iscan.infos.notTakenIntoAccount') + ' ' + this.translate.translate('iscan.infos.doYouWantContinue');
    } else {
      message = this.translate.translate('iscan.infos.doYouWantContinue');
    }
    this.confirmationService.confirm({
      message: message,
      accept: () => {
        this.saveFile();
      },
    });
  }
  
  saveFile(): boolean {
    this.spinner.show();
    const scanLinked = this.scan.splits.filter((element) => element.details.title !== 'Error' && element.details.title !== null);
    const data = [];
    this.iscanServices.saveSplit(this.guid, this.scan.splits).subscribe({
      next: () => {
        scanLinked.forEach((element) => {
          data.push({
            lotGuid: this.scan.guid,
            seanceId: element.details.title === 'Séance' ? +element.details.titleButton : null,
            pointId: element.details.title === 'Point' ? +element.details.titleButton : null,
            splitGuid: element.guid,
            fileDescription: element.name,
            barCode: null,
          });
        });
        return this.scanService.massAttachToMail(data, true).subscribe({
          next: () => {
            this.toastr.success(this.translate.translate('iscan.success.scanSave'));
            this.router.navigate(['private/iscan']);
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(this.translate.translate('iscan.error.saveScan'));
          }
        });
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(this.translate.translate('iscan.error.saveScan'));
      }
    });
    return true;
  }
}
